<template>
  <div class="out_wrap">
    <el-timeline>
      <el-timeline-item v-for="(item, index) in versions" :key="index" :timestamp="item.version + '    ——    ' + item.online_time" placement="top">
        <el-card>
          <div class="bold">更新描述：</div>
          <div style="line-height: 180%;" v-html="item.employer_desc" />
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <el-pagination v-if="versions.length > 0" background layout="total, sizes, prev, pager, next, jumper" :current-page="pageControl.page" :page-size="pageControl.pageSize" :page-sizes="pagesizes" :total="pageControl.total" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
  </div>
</template>

<script>
import { versionList } from '@/api/set'
export default {
  data() {
    return {
      pageControl: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      versions: []
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query(pg = 1) {
      this.pageControl.page = pg
      versionList({ page: this.pageControl.page, pageSize: this.pageControl.pageSize }).then(res => {
        if (res.code === 200) {
          this.versions = res.data.data || []
          this.pageControl.total = res.data.total
        }
      })
    },
    handleCurrentChange(val) {
      this.pageControl.page = val
      this.query()
    },
    handleSizeChange(val) {
      this.pageControl.pageSize = val
      this.pageControl.page = 1
      this.query()
    }
  }
}
</script>

<style>

</style>
